import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Point, Transform, TextureMatrix, Rectangle, Texture } from '@pixi/core';
import { Sprite } from '@pixi/sprite';
var tempPoint = new Point();
var TilingSprite = /*#__PURE__*/function (_Sprite) {
  _inherits(TilingSprite, _Sprite);
  var _super = _createSuper(TilingSprite);
  function TilingSprite(texture) {
    var _this;
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    _classCallCheck(this, TilingSprite);
    _this = _super.call(this, texture);
    _this.tileTransform = new Transform();
    _this._width = width;
    _this._height = height;
    _this.uvMatrix = _this.texture.uvMatrix || new TextureMatrix(texture);
    _this.pluginName = "tilingSprite";
    _this.uvRespectAnchor = false;
    return _this;
  }
  _createClass(TilingSprite, [{
    key: "clampMargin",
    get: function get() {
      return this.uvMatrix.clampMargin;
    },
    set: function set(value) {
      this.uvMatrix.clampMargin = value;
      this.uvMatrix.update(true);
    }
  }, {
    key: "tileScale",
    get: function get() {
      return this.tileTransform.scale;
    },
    set: function set(value) {
      this.tileTransform.scale.copyFrom(value);
    }
  }, {
    key: "tilePosition",
    get: function get() {
      return this.tileTransform.position;
    },
    set: function set(value) {
      this.tileTransform.position.copyFrom(value);
    }
  }, {
    key: "_onTextureUpdate",
    value: function _onTextureUpdate() {
      if (this.uvMatrix) {
        this.uvMatrix.texture = this._texture;
      }
      this._cachedTint = 16777215;
    }
  }, {
    key: "_render",
    value: function _render(renderer) {
      var texture = this._texture;
      if (!texture || !texture.valid) {
        return;
      }
      this.tileTransform.updateLocalTransform();
      this.uvMatrix.update();
      renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]);
      renderer.plugins[this.pluginName].render(this);
    }
  }, {
    key: "_calculateBounds",
    value: function _calculateBounds() {
      var minX = this._width * -this._anchor._x;
      var minY = this._height * -this._anchor._y;
      var maxX = this._width * (1 - this._anchor._x);
      var maxY = this._height * (1 - this._anchor._y);
      this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    }
  }, {
    key: "getLocalBounds",
    value: function getLocalBounds(rect) {
      if (this.children.length === 0) {
        this._bounds.minX = this._width * -this._anchor._x;
        this._bounds.minY = this._height * -this._anchor._y;
        this._bounds.maxX = this._width * (1 - this._anchor._x);
        this._bounds.maxY = this._height * (1 - this._anchor._y);
        if (!rect) {
          if (!this._localBoundsRect) {
            this._localBoundsRect = new Rectangle();
          }
          rect = this._localBoundsRect;
        }
        return this._bounds.getRectangle(rect);
      }
      return _get(_getPrototypeOf(TilingSprite.prototype), "getLocalBounds", this).call(this, rect);
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(point) {
      this.worldTransform.applyInverse(point, tempPoint);
      var width = this._width;
      var height = this._height;
      var x1 = -width * this.anchor._x;
      if (tempPoint.x >= x1 && tempPoint.x < x1 + width) {
        var y1 = -height * this.anchor._y;
        if (tempPoint.y >= y1 && tempPoint.y < y1 + height) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "destroy",
    value: function destroy(options) {
      _get(_getPrototypeOf(TilingSprite.prototype), "destroy", this).call(this, options);
      this.tileTransform = null;
      this.uvMatrix = null;
    }
  }, {
    key: "width",
    get: function get() {
      return this._width;
    },
    set: function set(value) {
      this._width = value;
    }
  }, {
    key: "height",
    get: function get() {
      return this._height;
    },
    set: function set(value) {
      this._height = value;
    }
  }], [{
    key: "from",
    value: function from(source, options) {
      var texture = source instanceof Texture ? source : Texture.from(source, options);
      return new TilingSprite(texture, options.width, options.height);
    }
  }]);
  return TilingSprite;
}(Sprite);
export { TilingSprite };